import { TypeSpacerFields } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import Spacer from './Spacer'

const ContentfulSpacer = withContentful<TypeSpacerFields>(Spacer)

export default ContentfulSpacer
